//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import page from "~/layouts/blog.vue";

// import "lite-youtube-embed/src/lite-yt-embed.css";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "NANCOMCY : 6 ANS ET TOUTES SES DENTS - NANCOMCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content: "L'agence de communication NANCOMCY fête ses 6 ans !",
        },
        {
          hid: "og:image",
          property: "og:image",
          content: require("~/assets/img/blog/thumbnail-header-6.jpeg"),
        },
      ],
    };
  },
};
